/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyMetafieldKeySummary
 */
export interface ShopifyMetafieldKeySummary {
  /**
   *
   * @type {string}
   * @memberof ShopifyMetafieldKeySummary
   */
  namespace: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyMetafieldKeySummary
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyMetafieldKeySummary
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyMetafieldKeySummary
   */
  owner: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyMetafieldKeySummary
   */
  sampleValue: string;
  /**
   *
   * @type {number}
   * @memberof ShopifyMetafieldKeySummary
   */
  occurrences: number;
}

/**
 * Check if a given object implements the ShopifyMetafieldKeySummary interface.
 */
export function instanceOfShopifyMetafieldKeySummary(
  value: object,
): value is ShopifyMetafieldKeySummary {
  if (!("namespace" in value) || value["namespace"] === undefined) return false;
  if (!("key" in value) || value["key"] === undefined) return false;
  if (!("owner" in value) || value["owner"] === undefined) return false;
  if (!("sampleValue" in value) || value["sampleValue"] === undefined)
    return false;
  if (!("occurrences" in value) || value["occurrences"] === undefined)
    return false;
  return true;
}

export function ShopifyMetafieldKeySummaryFromJSON(
  json: any,
): ShopifyMetafieldKeySummary {
  return ShopifyMetafieldKeySummaryFromJSONTyped(json, false);
}

export function ShopifyMetafieldKeySummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyMetafieldKeySummary {
  if (json == null) {
    return json;
  }
  return {
    namespace: json["namespace"],
    key: json["key"],
    type: json["type"] == null ? undefined : json["type"],
    owner: json["owner"],
    sampleValue: json["sampleValue"],
    occurrences: json["occurrences"],
  };
}

export function ShopifyMetafieldKeySummaryToJSON(
  json: any,
): ShopifyMetafieldKeySummary {
  return ShopifyMetafieldKeySummaryToJSONTyped(json, false);
}

export function ShopifyMetafieldKeySummaryToJSONTyped(
  value?: ShopifyMetafieldKeySummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    namespace: value["namespace"],
    key: value["key"],
    type: value["type"],
    owner: value["owner"],
    sampleValue: value["sampleValue"],
    occurrences: value["occurrences"],
  };
}
